module.exports = __webpack_public_path__ + "static/media/mascot02.ec17d786.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/mascot02.png
// module id = 179
// module chunks = 0